import { put, takeLatest } from 'redux-saga/effects';
import { CheckSN } from '../../reducers/r_index';

import authService from './../../components/api-authorization/AuthorizeService';

// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { sn, tipologia } }) {
    try {
        const token = yield authService.getAccessToken();

        const response = yield fetch('/Licenses/CheckSN/' + sn + '/' + tipologia, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });


        const resp = yield response.text();

        let is_sn_valid;

        if (resp === 'true') is_sn_valid = true;
        else is_sn_valid = false;


        yield put(CheckSN.creators.checkSNSuccess({ is_sn_valid }));

    } catch (e) {
        yield put(CheckSN.creators.checkSNFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(CheckSN.types.CHECK_SN_REQUEST, runAction);
}